var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhonePreviewVert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 38",
    style: {
      enableBackground: "new 0 0 25 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ADADAD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Preview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M22.8,5.9c0-1.4-1.2-2.6-2.6-2.6H4.7c-1.4,0-2.6,1.2-2.6,2.6v26.2c0,1.4,1.2,2.6,2.6,2.6h15.5 c1.4,0,2.6-1.2,2.6-2.6V5.9z M10.3,5.8h4.3c0.4,0,0.7,0.2,0.7,0.4s-0.3,0.4-0.7,0.4h-4.3c-0.4,0-0.7-0.2-0.7-0.4S9.9,5.8,10.3,5.8 z M12.5,32.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2C13.7,31.7,13.2,32.2,12.5,32.2z M20.4,28.9H4.6 V10.7h15.7V28.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePreviewVert);
export default __webpack_public_path__ + "static/media/PhonePreviewVert.a805de86.svg";
export { ForwardRef as ReactComponent };